import React, { useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import './App.scss';
import AppRoutes from './AppRoutes';
// import Navbar from './shared/Navbar';
import { withTranslation } from 'react-i18next';
import Login from './base-template/user-pages/Login';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavbarMain from './shared/NavbarMain';
import withStickyNavbar from './utils/Hoc/withStickyNavbar';
import { saveCustomerInfo } from '../store/actions/AuthAction';
import DialogContent from '@mui/material/DialogContent';
import axios from 'axios';
import instance from '../axiosRetail';
import instanceReport from '../axiosReport';
import instanceAuthn from '../axiosAuthen';
import instanceReleases from '../axiosRetailReleases';
import { getCookie } from './utils/cookies';
import LoadingStore from './shared/LoadingStore';
import closeWarning from '../assets/images/close-warning.svg';
import iconWarning from '../assets/images/icon-warning.svg';
import moment from "moment";
import 'moment/locale/vi';
import { setCookieLink, removeCookieLink, setCookieAgencyIds, getCookieAgencyIds } from './utils/cookiesLink';
import { checkWarning, cancelMaterialWarning } from './components/Product/Views/Ingredient/Controllers/apis'
import CacheBuster from './CacheBuster';

const NavbarWithSticky = withStickyNavbar(NavbarMain);

const App = ({ token, location, i18n, saveCustomerInfo }) => {
    useEffect(() => {
        onRouteChanged();
    }, [location]);

    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const userCookie = getCookie();

    const currentURL = window.location.href;
    const url = new URL(currentURL);
    const link = url.pathname;

    const WarningMaterial = ({ closeToast, data }) => {
        const requestCancel = {
            id: data.id,
            agencyId: data.agencyId,
            materialCode: data.code,
            cancelBy: userCookie ? JSON.parse(userCookie).fullName : null
        }
        const handleCancel = async () => {
            await cancelMaterialWarning(requestCancel).then(res => {
                toast.success("Hủy tem thành công")
            })
            closeToast(true);
        };

        return (
            <div style={{ backgroundColor: 'rgba(255, 247, 237, 1)', color: 'rgba(82, 82, 82, 1)', margin: '-9px -20px -7px -7px', fontSize: '1em' }}>
                <div className="w-100" style={{ paddingTop: '10px', marginBottom: '5px' }}>
                    <img src={iconWarning} style={{ width: '30px', height: '20px', verticalAlign: 'middle' }} />
                    <span style={{ fontWeight: 600, marginLeft: '10px', width: '250px', fontSize: '16px' }}>Cảnh báo nguyên liệu hết hạn</span>
                    {/* <img src={closeWarning} style={{width: '30px', height: '20px', float: 'right'}}/> */}
                </div>
                <div style={{ fontWeight: 600, marginLeft: '40px', fontSize: '14px' }}>{data.name} - {JSON.parse(data?.temInfo).standard}</div>
                <div style={{ marginLeft: '40px', fontSize: '14px' }}>Ngày mở: {data.printTime}</div>
                <div style={{ marginLeft: '40px', fontSize: '14px', marginBottom: '5px' }}>Đến hạn: {data.expiryTime}</div>
                <div className="d-flex" style={{ padding: '10px 40px' }}>
                    <button
                        aria-label="remove"
                        type="button"
                        style={{
                            backgroundColor: 'rgba(236, 106, 0, 1)',
                            color: '#FFFFFF',
                            padding: '5px 10px',
                            border: 'none',
                            borderRadius: '4px'
                        }}
                        onClick={() => {
                            closeToast(true);
                        }}
                    >
                        Đóng
                    </button>
                    <button
                        style={{
                            backgroundColor: 'rgba(236, 106, 0, 1)',
                            color: '#FFFFFF',
                            padding: '5px 10px',
                            border: 'none',
                            marginLeft: '10px',
                            borderRadius: '4px'
                        }}
                        onClick={() => handleCancel()}
                    >
                        Xác nhận hủy tem
                    </button>
                </div>
            </div>
        );
    };

    useEffect(() => {
        const run = async () => {
            const userData = userCookie ? JSON.parse(userCookie) : null;

            if (userData) {
                if (userData.username && userData.token) {
                    instance.defaults.headers.common['Authorization'] = userData.token;
                    instanceReport.defaults.headers.common['Authorization'] = userData.token;
                    instanceAuthn.defaults.headers.common['Authorization'] = userData.token;
                    instanceReleases.defaults.headers.common['Authorization'] = userData.token;
                    saveCustomerInfo({
                        token: userData.token,
                        username: userData.username,
                        role: userData.role,
                    });

                    const header = {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization, Content-Disposition',
                        'Access-Control-Expose-Headers': 'Content-Disposition',
                        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, HEAD, OPTIONS',
                        'Access-Control-Allow-Credentials': 'true',
                        Authorization: userData.token,
                    };
                    instance({
                        url: '/agency-permission/agency-by-user',
                        method: 'GET',
                    }).then(res => {
                        setCookieAgencyIds(res.data)
                        const cookieAgencyIds = getCookieAgencyIds();
                        const agencyIds = cookieAgencyIds && cookieAgencyIds !== null ? JSON.parse(cookieAgencyIds) : null
                        // Polling check cảnh báo hết hạn tem nguyên liệu 1 phút/1 lần
                        if (agencyIds && agencyIds !== null && agencyIds.length === 1) {
                            setInterval(async () => {
                                const request = {
                                    agencyId: agencyIds[0],
                                    timeCurrent: Math.round(Date.now() / 1000),
                                }
                                await checkWarning(request).then(res => {
                                    res.data && res.data.length > 0 && res.data.forEach(el => {
                                        toast(({ closeToast }) => (
                                            <WarningMaterial
                                                closeToast={closeToast}
                                                data={el}
                                            />
                                        ), {
                                            // Ẩn cảnh báo tự động sau 1 phút
                                            autoClose: 60000
                                        });
                                    })
                                })
                            }, [60000])
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                } else {
                    saveCustomerInfo({ token: '', fullName: '' });
                }
                removeCookieLink();
                setIsLoading(false);
            } else {
                saveCustomerInfo({ token: '', fullName: '' });
                setCookieLink(url.href);
                window.location.href = process.env.REACT_APP_LINK_WEB_LOGIN;
            }

            setUser(userData);
        };

        run();
    }, [userCookie]);

    const onRouteChanged = () => {
        const body = document.querySelector('body');
        if (location.pathname === '/layout/RtlLayout') {
            body.classList.add('rtl');
        } else {
            body.classList.remove('rtl');
        }
        i18n.changeLanguage('en');
        window.scrollTo(0, 0);
    };

    return (
        <CacheBuster>
            {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                if (loading) return null;
                if (!loading && !isLatestVersion) {
                    refreshCacheAndReload();
                }
                return (
                    <>
                        {isLoading ? (
                            <LoadingStore />
                        ) : (
                            <>
                                {token ? (
                                    <div className='container-scroller'>
                                        {!(
                                            String(link) === String('/manage-retail/create') ||
                                            String(link) === String('/customer-order') ||
                                            String(link) === String('/notFound') ||
                                            String(link) === String('/bartender') ||
                                            String(link) === String('/request-export-invoice/create')
                                        ) && <NavbarWithSticky />}

                                        <div className='content' style={{ background: '#f2edf3' }}>
                                            <div
                                                className='main-content container-fluid'
                                                style={{
                                                    padding:
                                                        String(link) === String('/bartender') ||
                                                            String(link) === String('/manage-retail/create') ||
                                                            String(link) === String('/customer-order')
                                                            ? 0
                                                            : '0 20px',
                                                }}
                                            >
                                                <div className='content-wrapper'>
                                                    <AppRoutes />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <LoadingStore />
                                )}
                            </>
                        )}
                        <ToastContainer className='custom-toast-container' pauseOnFocusLoss={false} autoClose={6000} />
                    </>
                );
            }}
        </CacheBuster>
    );
};

const mapStateToProps = (state) => {
    return {
        token: state.authReducer.detail.token,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveCustomerInfo: (data) => dispatch(saveCustomerInfo(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(App)));
